import { List } from "@mijadesign/web";
import type { CSSProperties } from "react";

type FlexConfig = {
  columnGap?: number;
  rowGap?: number;
};

type ListWrapperProps = {
  layoutMode?: "grid" | "flex";
  flex?: FlexConfig;
  grid?: Record<string, unknown>;
  className?: string;
  style?: CSSProperties;
  [key: string]: unknown;
};

function normalizeGap(value: unknown, fallback: number): number {
  return typeof value === "number" && Number.isFinite(value) ? value : fallback;
}

function buildFlexClassName(columnGap: number, rowGap: number): string {
  return `mija-list-flex-${columnGap}-${rowGap}`.replace(
    /[^a-zA-Z0-9_-]/g,
    "-",
  );
}

export default function ListWrapper(props: ListWrapperProps) {
  const {
    layoutMode = "grid",
    flex,
    grid: _grid,
    className,
    ...restProps
  } = props;
  if (layoutMode !== "flex") {
    return <List {...restProps} grid={_grid} className={className} />;
  }

  const columnGap = normalizeGap(flex?.columnGap, 16);
  const rowGap = normalizeGap(flex?.rowGap, 16);
  const flexClassName = buildFlexClassName(columnGap, rowGap);
  const mergedClassName = [className, flexClassName].filter(Boolean).join(" ");

  return (
    <>
      <style>
        {`
          .${flexClassName} .ant-list-items {
            display: flex;
            flex-wrap: wrap;
            column-gap: ${columnGap}px;
            row-gap: ${rowGap}px;
          }
        `}
      </style>
      <List {...restProps} className={mergedClassName} />
    </>
  );
}
